export default "__VITE_ASSET__26db4281__"